export function EmptyCellValue(): React.ReactNode {
  return <span className='text-gray-400 font-lato'>—</span>
}
